import { render } from "./TranslationPickerWidget.vue?vue&type=template&id=e28c0352&scoped=true"
import script from "./TranslationPickerWidget.vue?vue&type=script&lang=js"
export * from "./TranslationPickerWidget.vue?vue&type=script&lang=js"

import "./TranslationPickerWidget.vue?vue&type=style&index=0&id=e28c0352&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e28c0352"]])

export default __exports__